import { gql } from '@apollo/client';

export default gql`
  mutation destroyWarrantyImage($input: WarrantyImageDestroyInput!) {
    destroyWarrantyImage(input: $input) {
      clientMutationId
      warrantyImage {
        id
      }
    }
  }
`;
